import { render, staticRenderFns } from "./editor_correct.vue?vue&type=template&id=479ceb2b&scoped=true"
import script from "./editor_correct.vue?vue&type=script&lang=js"
export * from "./editor_correct.vue?vue&type=script&lang=js"
import style0 from "./editor_correct.vue?vue&type=style&index=0&id=479ceb2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ceb2b",
  null
  
)

export default component.exports